import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ScanResult, SkinGoal } from '../lib/types';

interface FlowState {
  realAge: number;
  goals: SkinGoal[];
  capturedImage: Blob | null;    // not persisted (Blob isn't JSON-serializable)
  scanResult: ScanResult | null;
  email: string;
  planToken: string | null;

  setAge: (age: number) => void;
  setGoals: (goals: SkinGoal[]) => void;
  setCapturedImage: (b: Blob | null) => void;
  setScanResult: (r: ScanResult | null) => void;
  setEmail: (e: string) => void;
  setPlanToken: (t: string | null) => void;
  reset: () => void;
}

export const useFlow = create<FlowState>()(
  persist(
    set => ({
      realAge: 0,
      goals: [],
      capturedImage: null,
      scanResult: null,
      email: '',
      planToken: null,

      setAge: realAge => set({ realAge }),
      setGoals: goals => set({ goals }),
      setCapturedImage: capturedImage => set({ capturedImage }),
      setScanResult: scanResult => set({ scanResult }),
      setEmail: email => set({ email }),
      setPlanToken: planToken => set({ planToken }),
      reset: () =>
        set({
          realAge: 0,
          goals: [],
          capturedImage: null,
          scanResult: null,
          email: '',
          planToken: null,
        }),
    }),
    {
      name: 'lume-flow',
      // Only persist the small, JSON-safe pieces.
      partialize: state => ({
        realAge: state.realAge,
        goals: state.goals,
        scanResult: state.scanResult,
        email: state.email,
        planToken: state.planToken,
      }),
    },
  ),
);
